module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.84cf469.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/font/notokr-bold.woff
// module id = 0KBi
// module chunks = 0